import { useTranslation } from "react-i18next";
import { formatTranslation } from "../../../shared/utils/translationUtils";

type SeedTranslationOptions = Record<string, string | number>;

type SeedTranslator = (key: string, options?: SeedTranslationOptions) => string;

const useSeedTranslations = (): SeedTranslator => {
  const { t } = useTranslation();

  return (key: string, options?: SeedTranslationOptions): string => {
    return formatTranslation(
      t(`newRatesAndDosage.seeds.${key}`, options),
      options
    );
  };
};

export default useSeedTranslations;
